/**
 * The "Getting things ready" line (25i), on its own so the app shell's
 * banner can import it without the whole onboarding copy module (entry
 * chunk). Re-exported from `../copy.js` with the rest of the step's copy.
 */

/**
 * @param {number} done
 * @param {number} total
 * @returns {string}
 */
export const gettingReady = (done, total) => `Getting things ready — ${done} of ${total} done`
